/**
 * Read More JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class StickyNav
 */
class ReadMore {

    /**
     * All common events
     * @return {void}
     */
    events() {

        var clickedButtonId;
        var clickedButton;
        var divId;
        var div;
        var button;

        // Read more button clicked
        $( '.read-more-button' ).click( function() {

            // The button id, element type is div
            clickedButtonId = this.id;

            // Button id contains identifying number
            clickedButton = clickedButtonId.split( '-' );

            // The text containing div id which we want to hide or show
            divId = 'read-more-' + clickedButton[1];

            // The text containing div element
            div = $( '#' + divId );

            // The button, element type is div
            button = $( '#' + clickedButtonId );

            // Show hidden text
            div.removeClass( 'js-hidden' );

            // Hide button
            button.addClass ( 'js-hidden' );

            // Change aria states
            button.attr( 'aria-expanded', 'true' );
            div.attr( 'aria-hidden', 'false' );
        });
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.events();
    }
}

// Export the class reference.
module.exports = ReadMore;



// WEBPACK FOOTER //
// ./assets/scripts/read-more.js